import { InjectionToken } from '@angular/core';

/** DOM window DI token. */
export const WINDOW = new InjectionToken<Window>('WindowToken');

/** DOM window factory function. */
export function windowFactory(): any {
  return window;
}
